import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type HostImageData } from '../api/client';

const IMAGES_KEY = ['images'] as const;

export function useImages() {
  return useQuery<HostImageData[]>({
    queryKey: IMAGES_KEY,
    queryFn: () => api.images.list(),
  });
}

export function useUploadImage() {
  const queryClient = useQueryClient();

  return useMutation<HostImageData, Error, { data: string; filename: string; mimeType: string }>({
    mutationFn: (input) => api.images.upload(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: IMAGES_KEY });
    },
  });
}

export function useDeleteImage() {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, Error, string>({
    mutationFn: (imageId) => api.images.delete(imageId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: IMAGES_KEY });
    },
  });
}
